// This file provides types that FOND service translates and returns as a response
// NOT actual Stripe object types

import { ObjectValues, Unionize } from "./generic";

export type SetupIntentClientSecretResponse = {
  ClientSecret: string;
};

export const ProductCategory = {
  subscription: "subscription",
  license: "license",
  data_pack: "data_pack",
} as const;
export type ProductCategory = ObjectValues<typeof ProductCategory>;

export const ProductAddons = ["planner"] as const;
export type ProductAddon = Unionize<typeof ProductAddons>;

export const PurchaseType = {
  // One off purchases
  one_off: "one_off",
  // Creation of purchases that start a new billing cycle
  first_time_purchase: "purchase",
  // Modifications to the current billing cycle
  update: "update",
  // Modifications that effect the next billing cycle
  future: "future",
} as const;
export type PurchaseType = ObjectValues<typeof PurchaseType>;

export const PaymentFrequencies = ["monthly", "quarterly", "yearly"] as const;
export type PaymentFrequency = (typeof PaymentFrequencies)[number];

export const PaymentFrequencyStepLabel = {
  monthly: "month",
  quarterly: "quarter",
  yearly: "year",
} as const;

export type ProductPrice = {
  ID: string;
  StripePriceID: string;
  CostCents: number;
  PaymentFrequency: PaymentFrequency;
  OrderID: number;
  BaseQuota: number | null;
};

export type Product<C extends ProductCategory = ProductCategory> = {
  ID: string;
  Name: string;
  Title: string;
  Prices: ProductPrice[];
  Category: C;
};

export type SubscriptionTier = {
  ID: string;
  Product: Product<"subscription">;
  DataPackProduct: Product<"data_pack">;
  TierLevel: number;
};

export type LineItem = {
  PriceID: string;
  Quantity: number;
};

type TaxAmount = {
  Amount: number;
  Inclusive: boolean;
  TaxabilityReason: string;
  TaxableAmount: number;
};

type Discount = {
  Coupon: {
    Name: string;
  } & ({ AmountOff: number; PercentOff: null } | { AmountOff: null; PercentOff: number });
};

type TotalDiscountAmounts = {
  Amount: number;
  Discount: Discount;
};

export type SummaryLine = {
  AmountExcludingTax: number;
  Description: string;
  Quantity: number;
};

type SummaryLines = {
  Data: SummaryLine[];
};

type Coupon = {
  // The name of the coupon
  CouponName: string;
  // The promo code string that was applied to get the discount
  PromoCode: string | null;
};

export type PurchaseSummary = {
  Lines: SummaryLines;
  Subtotal: number;
  Total: number;
  TotalExcludingTax: number;
  TotalTaxAmounts: TaxAmount[];
  TotalDiscountAmounts: TotalDiscountAmounts[];
  CouponsApplied: Coupon[] | null;
  InvalidPromoCodes: Array<{
    PromoCode: string;
    Reason: string;
  }>;
};
